import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Question } from '@/components/qrender/types'
import MyAudio from '@/components/qrender/components/Audio.vue'
import { getQuestionDetail } from '@/apps/h5/model/api'
import { addWatermark } from '@/utils/waterMarker'
@Component({ components: { MyAudio } })
export default class H5Question extends Vue {
    @Prop() public q!: Question
    @Prop() public startIndex!: number
    @Prop() public showAnalysis!: false
    @Prop() public showDropdown!: false

    public questionDetailData!: Question

    public get paperInfo() {
        return this.q && this.q.paper_info || {
            paper_info_text: '',
            paper_id: ''
        }
    }
    public get score() {
        return this.q && this.q.score && this.q.score.score ? `(${this.q.score.score}分)` : ''
    }
    private get originBy() {
        let str = ''
        if (this.q && this.paperInfo.paper_info_text) {
          str = `<a class="origin_by" href="javascript:void(0);">【${this.paperInfo.paper_info_text}】</a>`
        }
        return str
    }

    private get renderQHtml() {
        // 插值
        let reg = /<q-head-placeholder>.*<\/q-head-placeholder>/
        let idx =
          this.startIndex >= 0
            ? '<span class="q-number-index">' + (this.startIndex + 1) + '、</span>'
            : ''
        let ret = ''
        if (this.showAnalysis) {
          ret = this.q.render_detail_text
            ? this.q.render_detail_text
                .replace(/<\s*blank\s*\/>/g, '<blank></blank>')
                .replace(
                  reg,
                  `<q-head-placeholder>${idx}${this.score}${this.originBy}</q-head-placeholder>`
                )
            : [this.q.render]
                .map((item) => {
                  return (item || '').replace(/<\s*blank\s*\/>/g, '<blank></blank>') // 处理自闭合的blank标签
                })
                .join('')
                .replace(
                  reg,
                  `<q-head-placeholder>${idx}${this.score}${this.originBy}</q-head-placeholder>`
                )
        } else {
          ret = [this.q.render]
            .map((item) => {
              return (item || '').replace(/<\s*blank\s*\/>/g, '<blank></blank>') // 处理自闭合的blank标签
            })
            .join('')
            .replace(
              reg,
              `<q-head-placeholder>${idx}${this.score}${this.originBy}</q-head-placeholder>`
            )
        }
        return ret
    }
    @Watch('showAnalysis')
    public onShowAnalysisChange(val) {
      // 停止所有的音频播放
      window.postMessage({ action: 'playing-audio', id: '' }, location.origin)
    }
  
    @Watch('renderQHtml', { immediate: true })
    public onRenderQHtmlChange(val) {
      const that = this
      if (!val) return
      // treate placeholder as component
      this.$nextTick(() => {
        const htmlDiv: any = this.$refs.q_body
        const audios = htmlDiv.querySelectorAll('q-audio-placeholder')
        audios.forEach((item) => {
          const src = item.getAttribute('src')
          const Vue2 = (window as any).vue
          new Vue2({
            data: {
              src
            },
            render(h) {
              return h(MyAudio, { props: { audioUrl: src, qid: that.q.id } })
            }
          }).$mount(item)
        })
      })
    }

    // methods
    public navigateTo() {
      const uni = (window as any).uni
      uni.navigateTo({
        url: `/pages/common/question-info/question-info?id=${this.q.id}`
      })
    }
    public async clickShowAnalysis() {
      this.$emit('clickShowAnalysis')
    }

    public renderWaterMark() {
      setTimeout(() => {
        addWatermark([this.$refs.question], `一起题库网`)
      },0)
    }

    public mounted() {
      this.renderWaterMark()
    }
}